import { httpClient } from "@services/api/httpClient";

interface GetOfferParams {
  uuid: string
}

export async function getPublicOfferByUUID({uuid }: GetOfferParams) {
  const response = await httpClient.get("/offer/public/get-by-uuid", {
    params: { uuid }
  });
  return response.data;
}